import { render, staticRenderFns } from "./ProjectsSearch.vue?vue&type=template&id=b4ff69d0&"
import script from "./ProjectsSearch.vue?vue&type=script&lang=js&"
export * from "./ProjectsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports